(function () {
  const slides = document.querySelectorAll(".promo-slide");
  const prevBtn = document.querySelector(".promo-banner-prev-btn");
  const nextBtn = document.querySelector(".promo-banner-next-btn");
  let count = 0;
  if (!slides.length) return; // Exit if no slides are found
  prevBtn?.addEventListener("click", () => changeSlide(-1));
  nextBtn?.addEventListener("click", () => changeSlide(1));
  function changeSlide(direction) {
    count = (count + direction + slides.length) % slides.length;
    updateSlides();
  }
  function updateSlides() {
    slides.forEach((slide) => {
      slide.style.transform = `translateX(-${100 * count}%)`;
    });
  }
})();
